export default __webpack_public_path__ + "static/media/595.00a532cf.gif";